import React from "react";
import {Button, Form, Input, message, Modal, Select, InputNumber } from "antd";
import { ScanOutlined } from '@ant-design/icons';
import Can from '../../components/ability';
import AppIconGroup from '../../components/app-icon-group';
import SwitchShop from '../shop/switch-shop';
import Record from "./record";
import { getCurrentShopId } from "../shop/get-current-shop";
import { scanQRCode } from '../../utils/jsbridge';

export default () => { 
    const [form] = Form.useForm();
    const [usedList, setUsedList] = React.useState([]);
    const [isOpen, setIsOpen] = React.useState(false);
    const [shopId, setShopId] = React.useState(null);
    
    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        
        fetchShopId();
    }, []);
    
    React.useEffect(() => {
        if (shopId) {
            getVeriyRecord();
        }
    }, [shopId]);
    const submit = async () => {
        const values = await form.validateFields();
        values.shopId = await getCurrentShopId();
        console.log('Success:', values);

        await writeoff(values);
    };

    const writeoff = async ({id, shopId}) => {
        const response = await fetch('/api/writeoff', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id,
                shopId
            })
        });

        const result = await response.json();

        if(result?.success) {
            message.success('核销成功');
            getVeriyRecord();
        }else{
            message.error(result.data);
        }
    };

    // 唤起摄像头扫码
    const openScanModal = async () => { 
        try {
            const result = await scanQRCode();
            // 扫描成功，自动提交核销
            Modal.confirm({
                title: '核销码',
                content: result.data,
                okText: '核销',
                onOk() {
                    // 扫描成功，自动提交核销
                    submitWriteoff(result.data);
                }
            });
            // submitWriteoff(result.data);
        } catch (error) {
            console.error('Scan failed:', error);
            if (error.message !== 'User cancelled QR code scanning') {
                message.error(error.message || '扫码失败');
            }
        }
    };

    const submitWriteoff = async (id) => {
        if (!shopId) return;
        await writeoff({id, shopId});
    };

    const getVeriyRecord = async () => {
        if (!shopId) return;
        const response = await fetch(`/api/verify/used-list?shopId=${shopId}`);
        const res = await response.json();
        
        if(res?.success) {
            setUsedList(res?.data?.rows || []);
        }
    }

    return ( 
        <div className="space-y-4">
            <SwitchShop />
            
            <AppIconGroup 
                items={[
                    {
                        id: 1,
                        title: '扫码核销',
                        icon: <ScanOutlined />,
                        color: 'from-blue-500 to-blue-600',
                        onClick: openScanModal,
                        permission: {
                            action: 'read',
                            subject: 'order'
                        }
                    }
                ]}
            />
            
            <div className="admin-card p-4">
                <h2 className="admin-section-title mb-3">输码核销</h2>
                <Form form={form} layout="vertical">
                    <Form.Item label="核销码" name="id" rules={[{ required: true, message: '请输入核销码' }]}> 
                        <InputNumber step={1} className="w-full admin-form-input" placeholder="请输入核销码" />
                    </Form.Item>
                    <div className="admin-form-actions justify-center">
                        <Button size="large" type='primary' onClick={submit} className="min-w-[100px]">核销</Button>
                    </div>
                </Form>
            </div>
            
            <div>
                <h2 className="admin-page-title">核销记录</h2>
                <Record dataSource={usedList} />
            </div>
        </div>
    );
};